<template>
  <div class="dropdown-menu">
    <div
      class="search-result d-flex align-items-center mx-2 px-2 py-1"
      :class="{ active: Object.keys(activeResult).length === 0 }"
    >
      <span class="result-title flex-grow-0 mr-auto" v-html="text"></span>
      <span class="btn btn-sm btn-light">
        <i class="fas fa-plus" />
      </span>
    </div>
    <search-result
      v-for="note in notesFound"
      :result="note"
      :active-result="activeResult"
      :query="text"
      :current-note="currentNote"
      :key="note.id"
      @click="createLink(note.title)"
    ></search-result>
  </div>
</template>
<script>
import SearchResult from '@/components/Search/SearchResult'
export default {
  components: {
    SearchResult
  },
  props: ['text', 'currentNote'],
  data() {
    return {
      notesFound: [],
      activeResult: {}
    }
  },
  methods: {
    createLink(title) {
      this.$emit('createLink', title)
    },
    setActiveResult(direction) {
      const index = this.notesFound.findIndex(note => note.id === this.activeResult.id)
      const newIndex = index + direction < this.notesFound.length
        ? index + direction >= -1
          ? index + direction
          : this.notesFound.length - 1
        : -1
      this.activeResult = newIndex >= 0 ? this.notesFound[newIndex] : {}
    },
    handleAutocompleteKeypress({ keyCode }) {
      const keyCodes = {
        cycle: [38, 40],
        confirm: [13]
      }
      if (keyCodes.cycle.includes(keyCode)) {
        const direction = keyCode === 38 ? -1 : 1
        this.setActiveResult(direction)
      } else if (keyCodes.confirm.includes(keyCode)) {
        this.createLink(this.activeResult.title)
      }
    }
  },
  watch: {
    text: {
      handler() {
        this.notesFound = (
          this.text.length > 0
            ? this.$store.getters.notesByQuery(this.text, { titleOnly: true })
            : this.$store.getters.notes.slice(0, 5)
        ).filter(note => note.id !== this.currentNote.id).sort((a, b) => b.modified - a.modified).slice(0, 5)
        this.activeResult = {}
      },
      immediate: true
    }
  }
}
</script>
<style scoped>
.dropdown-menu {
  display: block;
  top: initial;
  width: 250px;
}
.btn {
  font-size: 0.5rem;
}
</style>
